 export enum ParametrageModuleIdEnum {
LVL_VALID = 0,
PST_ACTIVE = 1,
MODE_TEST = 2,
URL_AUTH = 3,
URL_DEPOT = 4,
URL_RETOUR = 5,
SERVICE = 6,
IDENTIFIANT_NOM = 7,
IDENTIFIANT_PRENOM = 8,
IDENTIFIANT_MDP = 9,
IDENTIFIANT_SIRET = 10,
MODE_DEMARRAGE = 11,
NUMERO_ICARE = 12,
URL_PST = 13,
MAIL_PST = 14,
TRAITEMENT_EN_COURS = 15,
PAIE_ACTIVE = 16,
DERNIER_ENVOIE_FACTURATION = 17,
MODE_CONGE = 18,
DATE_DEMARAGE = 19,
DERNIER_NUMERO_VIREMENT = 20,
DERNIER_NUMERO_OD = 21,
MAIL_GESTIONNAIRE_PST = 22,
DATE_DERNIER_EVENEMENT = 23,
URL_RETOUR_TELECHARGEMENT = 24,
REPERTOIRE_RACINE = 25,
GESTIONNAIRE_PST_NOM = 26,
GESTIONNAIRE_PST_PRENOM = 27,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/ParametrageModuleIdEnum.ts